module.exports = __webpack_public_path__ + "static/media/pl.b2979a9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/pl.svg
// module id = 1463
// module chunks = 0